const getPaths = (paths: object, values = []): string[] => {
  if (typeof paths !== "object") {
    return [...values, paths];
  }
  return Object.values(paths).flatMap((v) => getPaths(v, values));
};

export const BOOKING = Object.freeze({
  AUTOTIMES: "/autotimes",
  COMPLETE: "/complete",
  DATE: "/date",
  DETAILS: "/details",
  ENQUIRY: "/enquiry",
  ENQUIRY_COMPLETE: "/enquirycomplete",
  PAX: "/pax",
  PAYMENT: "/payment",
  ROOMS: "/rooms",
  ROOT: "/",
  SIMPLE_TEE_TIMES: "/simpleteetimes",
  TIMES: "/times",
} as const);

const YGT_HOST = import.meta.env.VITE_API_HOST;

const MY_ACCOUNT = Object.freeze({
  SIGN_IN: `${YGT_HOST}/sign_in`,
  SIGN_UP: `${YGT_HOST}/sign_up`,
  MY_ACCOUNT: `${YGT_HOST}/my_account`,
});

// Combined paths
export const PATHS = Object.freeze({
  BOOKING,
  MY_ACCOUNT,
} as const);

const _pathValues = getPaths(PATHS);

export type Path = (typeof _pathValues)[number];
